export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? 'brand--compact' : ''}`}>
      <span className="brand__mark" aria-hidden="true">N</span>
      <span className="brand__text">
        <strong>Negocio360</strong>
        {!compact && <small>Control operativo</small>}
      </span>
    </div>
  );
}
